import { createContext, useContext } from "react";
import { Address, Bot, Project } from "@/types";

export interface AlertsState {
  projects: {
    id: string;
    name: string;
    bots: Bot[];
    botCount: number;
    status: string;
    addresses: Address[];
  }[];
  addBots: (projectId: string, bots: Bot[]) => void;
  setProjectBotCount: (projectId: string, botCount: number) => void;
  updateBot: (projectId: string, botId: string, bot: Bot) => void;
  deleteBot: (projectId: string, botId: string) => void;
  setProjects: (project: Project[]) => void;
  currentProjectId: string;
  setCurrentProjectId: (id: string) => void;
}

export const alertsInitialState: AlertsState = {
  projects: [],
  addBots: () => {},
  setProjects: () => {},
  currentProjectId: "",
  setCurrentProjectId: () => {},
  setProjectBotCount: () => {},
  updateBot: () => {},
  deleteBot: () => {},
};

export const AlertsContext = createContext<AlertsState>(alertsInitialState);

export const useAlerts = () => useContext(AlertsContext);
